export function gTagReportConversion(url) {
  const callback = function () {
    if (typeof (url) !== 'undefined') {
      // we will handle redirect logic outside
      // window.location = url;
    }
  };
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-923371515/mFWFCLis2PcaEPuPprgD',
      event_callback: callback,
    });
  }
  return false;
}
